import { useMutation } from '@tanstack/react-query';

import { toast } from '@ekhodealer/ekho-common/rev';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { apiClient } from '@config/server/apiClient';
import { ordersEndpoints } from '@config/server/apiEndpoints';

/**
 * API function to download VOS packet
 */
export const downloadVosPacket = async (
	servicesProviderId: string,
	orderId: string,
): Promise<void> => {
	await apiClient.downloadFile(
		ordersEndpoints.downloadVosPacket(servicesProviderId, orderId),
		undefined,
		'application/pdf',
		'vos-packet.pdf',
	);
};

/**
 * Hook for downloading VOS packet
 * @param orderId - The purchased vehicle ID (orderId in frontend terms)
 */
export const useDownloadVosPacket = (orderId: string | undefined) => {
	const servicesProviderId = useCurrentServicesProviderId();

	return useMutation({
		mutationFn: async () => {
			if (!orderId) {
				throw new Error('Unable to download VOS packet without an order ID.');
			}
			if (!servicesProviderId) {
				throw new Error('Unable to download VOS packet without a services provider ID.');
			}
			return downloadVosPacket(servicesProviderId, orderId);
		},
		onSuccess: () => {
			toast({
				message: 'VOS packet downloaded successfully',
				variant: 'success',
			});
		},
		onError: (error) => {
			const errorMessage =
				error instanceof Error ? error.message : 'Failed to download VOS packet';
			toast({
				message: errorMessage,
				variant: 'error',
			});
		},
	});
};

